export const GOOGLE_REFERER = "google";
export const YANDEX_REFERER = "yandex";
export const CHECK_PAYMENT_STATE_PERIOOD_MS = 2000;
